<template>
    <div class="message-filter-group">
        <div class="control-buttons" v-if="showRemoveButton">
            <div class="control-button">
                <md-button class="md-icon-button md-mini" @click="() => onRemoved(clone.id)">
                    <md-icon>delete_outline</md-icon>
                </md-button>
            </div>
        </div>

        <SingleFilter
            v-for="(filter, index) of clone.items"
            v-model="clone.items[index]"
            :enable-operator-changed="clone.items.length > 1"
            :operator="clone.operator"
            :on-operator-changed="onOperatorChanged"
            :selected="filter.id === selectedFilterId"
            :on-selected="() => (selectedFilterId = filter.id)"
            :on-canceled="() => (selectedFilterId = null)"
            :on-removed="onFilterRemoved"
            :key="filter.id"
            :group-id="value.id"
            :on-group-select-hovered="(hovered) => (groupSelectHovered = hovered)"
            :group-select-hovered="groupSelectHovered"
            :add-filter-mode="true"
            :show-operator-select="clone.items.length === 1 ? false : index !== clone.items.length - 1"
            :on-attribute-picked="onAttributePicked"
        />
    </div>
</template>

<script>
import SingleFilter from "../filter/SingleFilter";
import AttributePicker from "../../pickers/AttributePicker";
import { generateRandomId } from "../../../../../../../utils/session";
import _ from "lodash";
import log2 from "../../../../../../../utils/log2";
import CONFIG from "../../../../../../../config/config";
import systemAttributes from "../../../../utils/systemAttributes";

const log = log2("MessageFilterList");
export default {
    name: "MessageFilterList",
    components: {
        SingleFilter,
        AttributePicker,
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                operator: "or",
                items: [
                    {
                        id: generateRandomId(),
                        rule: "greater_or_equal",
                        attribute: "email",
                        value: 0,
                    },
                ],
            }),
        },
        onRemoved: {
            type: Function,
            required: true,
        },
        showRemoveButton: {
            type: Boolean,
            required: true,
        },
        defaultSelectedFilterId: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            selectedFilterId: this.defaultSelectedFilterId,
            attributePickerVisible: false,
            clone: _.cloneDeep(this.value),
            groupSelectHovered: false,
        };
    },
    methods: {
        onOperatorChanged(operator) {
            this.clone.operator = operator;
        },
        onAttributePicked(attribute) {
            const id = generateRandomId();

            const foundAttr =
                systemAttributes.find((x) => x.value === attribute) ||
                CONFIG.AKINON.attributes.find((x) => x.value === attribute) ||
                CONFIG.IDEASOFT.attributes.find((x) => x.value === attribute) ||
                CONFIG.PROBEL.attributes.find((x) => x.value === attribute);
            let rule = _.get(foundAttr, "defaultOperator", "equal");
            let value = _.get(foundAttr, "defaultFilterValue", 0);
            if (attribute === "akinon_order_status") {
                value = CONFIG.AKINON.ORDER_STATUSES.DELIVERED;
                rule = "equal";
            }
            this.clone.items.push({
                id,
                rule,
                attribute,
                value,
            });
            this.attributePickerVisible = false;
            this.selectedFilterId = id;
        },
        onFilterRemoved(id) {
            log("onFilterRemoved", id);
            this.clone.items = this.clone.items.filter((filter) => filter.id !== id);
            if (this.selectedFilterId === id) {
                this.selectedFilterId = null;
            }
        },
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(newValue) {
                this.$emit("input", newValue);
            },
            deep: true,
        },
        defaultSelectedFilterId(newVal) {
            this.selectedFilterId = newVal;
        },
    },
};
</script>

<style lang="scss">
.message-filter-group {
    grid-row-gap: 15px;
    border-radius: 4px;
    display: grid;
    position: relative;
    margin-bottom: 20px;

    &:hover {
        .control-buttons {
            opacity: 1;
        }
    }

    .control-buttons {
        height: 100%;
        left: -44px;
        opacity: 0;
        position: absolute;
        top: 0;
        transition: opacity 0.3s;
        width: 44px;

        .md-button {
            background-color: #fff;
            align-items: center;
            border-radius: 100%;
            box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
            cursor: pointer;
            display: flex;
            justify-content: center;
            margin-bottom: 7px;
            transition: background-color 0.3s;
            height: 30px;
            width: 30px;
            min-height: 30px !important;
            min-width: 30px !important;

            .md-icon {
                color: #006cff;
            }
        }
    }

    .filter-row {
        grid-column-gap: 10px;
        display: grid;
        grid-template-columns: minmax(0, 1fr) 10px;
        width: 100%;

        .add-filter-button {
            align-items: center;
            border: 1px solid #c6cdd4;
            border-radius: 4px;
            color: #006cff;
            cursor: pointer;
            display: flex;
            font-weight: 600;
            padding: 8px 15px;
            transition: border 0.3s, opacity 0.3s;

            &:hover {
                border-color: #006cff;
            }
        }

        &.empty {
            grid-template-columns: minmax(0, 1fr);
        }
    }
}
</style>
